import { ItemType } from "@/module/Item/ItemType";

enum ForeignVatType {
  ELECTRONIC_SERVICE = "electronic-service",
  ELECTRONIC_PUBLICATION = "electronic-publication",
  PRINTED_PUBLICATION = "printed-publication",
  LIVE_EVENT = "live-event",
  ELECTRONIC_PERIOD_PUBLICATION = "electronic-period-publication",
  PRINTED_PERIOD_PUBLICATION = "printed-period-publication",
  FOOD = "food",
}

const itemTypeToForeignVatTypeMap = {
  [ItemType.ELECTRONIC_PUBLICATION]: ForeignVatType.ELECTRONIC_PUBLICATION,
  [ItemType.ELECTRONIC_SERVICE]: ForeignVatType.ELECTRONIC_SERVICE,
  [ItemType.GOOD]: ForeignVatType.ELECTRONIC_SERVICE,
  [ItemType.FOOD]: ForeignVatType.FOOD,
  [ItemType.PRINTED_PUBLICATION]: ForeignVatType.PRINTED_PUBLICATION,
  [ItemType.LIVE_EVENT]: ForeignVatType.LIVE_EVENT,
  [ItemType.PRINTED_PERIOD_PUBLICATION]:
    ForeignVatType.PRINTED_PERIOD_PUBLICATION,
  [ItemType.ELECTRONIC_PERIOD_PUBLICATION]:
    ForeignVatType.ELECTRONIC_PERIOD_PUBLICATION,
} as { [key: string]: ForeignVatType };

const itemTypeToForeignVatType = (itemType: ItemType): ForeignVatType => {
  return itemTypeToForeignVatTypeMap[itemType];
};

export { ForeignVatType, itemTypeToForeignVatType };
